import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';

@Directive({
  selector: '[scroll-to]'
})
export class ScrollToDirective {
  constructor(private element: ElementRef, public renderer: Renderer2, private sharedService: SharedService) { }
  @Input('scroll-to') selector: string;
  @Input('scroll-top') scrollTop?: number;
  ngOnInit() {
    var element = (<HTMLInputElement>this.element.nativeElement);
    this.renderer.listen(element, 'click', (event: MouseEvent) => {
      if (this.scrollTop)
        this.sharedService.scrollToTop(this.selector, this.scrollTop);
      else
        this.sharedService.scrollIntoView(this.selector);
    });
  }
}
